export default __webpack_public_path__ + "static/media/teleconsult-on-demand-1.a276dbd9.png";